import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  TermsConditionsEN,
  TermsConditionsES,
  TermsConditionsRU,
  TermsConditionsRO,
  TermsConditionsPT
} from './TermsConditionsContent';
import GamePageLayout from '../Layout/GamePageLayout';

const TermsConditions: React.FC = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Map of language-specific terms and conditions content components
  const termsConditionsComponents = {
    en: TermsConditionsEN,
    es: TermsConditionsES,
    ru: TermsConditionsRU,
    ro: TermsConditionsRO,
    pt: TermsConditionsPT,
  };

  // Get the appropriate component based on current language, fallback to English
  const TermsConditionsContent = termsConditionsComponents[currentLanguage as keyof typeof termsConditionsComponents] || TermsConditionsEN;

  return <GamePageLayout title={t('footer.termsConditions')} showFooter={true} showHowToPlay={false} wide={true}>
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
      <TermsConditionsContent />
    </div>
  </GamePageLayout>
};

export default TermsConditions;